import UserService from '@/services/user.service';
import axios from "axios";

export const teacherModule = {
    namespaced: true,
    state: {
        requests: [],
        teacher: {},
        teachers: new Map()
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createTeacher({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createTeacher");
            data.role_id = '$teacher'
            return UserService.createUser(axiosSource, data).then(
                async data => {
                    commit('insertTeacher', data)
                    await dispatch('clearRequest', "createTeacher");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateTeacher({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateTeacher");
            return UserService.updateUser(axiosSource, data).then(
                async data => {
                    commit('updateTeacherData', data)
                    await dispatch('clearRequest', "updateTeacher");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteTeacher({commit, dispatch}, teacherId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteTeacher");
            return UserService.deleteUser(axiosSource, teacherId).then(
                async data => {
                    commit('removeTeacherFromList', teacherId)
                    await dispatch('clearRequest', "deleteTeacher");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getTeacher({commit, dispatch}, teacherId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getTeacher");
            return UserService.getUser(axiosSource, teacherId).then(
                async data => {
                    commit('updateActiveTeacher', data)
                    await dispatch('clearRequest', "getTeacher");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        listTeachers({commit}) {
            return UserService.listUsersByRole('$teacher').then(
                data => {
                    commit('updateTeachersList', data);
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateTeachersList(state, data) {
            state.teachers = new Map()
            for (const entity of data) {
                entity.phone = entity.phone?.replace('+98', '0')
                state.teachers.set(entity.id, entity)
            }
        },
        insertTeacher(state, data) {
            state.teachers.set(data.id, data)
        },
        updateTeacherData(state, data) {
            state.teachers.set(data.id, data)
        },
        removeTeacherFromList(state, teacherId) {
            state.teachers.delete(teacherId)
        },
        updateActiveTeacher(state, data) {
            state.teacher = data;
        }
    }
};